/**
 * I am a diacritics remover.
 *
 * :param text: text to normalize
 *
 * :returns: normalized text
 */
const removeDiacritics = (text: string): string =>
{
    // define diacritics map
    const diacritics: (string | RegExp)[][] = [
        [/[\340-\346]/g, 'a'],
        [/[\350-\353]/g, 'e'],
        [/[\354-\357]/g, 'i'],
        [/[\362-\370]/g, 'o'],
        [/[\371-\374]/g, 'u'],
        [/[\361]/g, 'n'],
        [/[\347]/g, 'c'],
    ];

    // set text to lowercase format
    let normalized = text.toLowerCase();

    // replace diacritics sinals
    diacritics.map(([from, to]: (string | RegExp)[]): void =>
    {
        normalized = normalized.replace(from, String(to));
    });

    // return normalized text
    return normalized;
};


/**
 * EXPORTS
 */
export default removeDiacritics;
